export default {
    'errno': 0,
    'errmsg': 'ok',
    'serverTime': 1677224179,
    'data': {
        'count': 3,
        'sys_count': 2,
        'sys_msg': {
            'id': 0,
            'icon': '',
            'FromSource': '',
            'create_time': 0,
            'msg_txt': '当前作品已通过审核，快去看看吧～',
            'link_txt': '',
            'link_url': '',
            'img_url': '',
            'status': '',
            'addr': '',
            'jump_url': ''
        }
    }
};